






























































import { DateRange } from 'inscreva-sse-models';
import moment from 'moment';
import { Component, Vue, Prop } from 'vue-property-decorator';

import { Event } from '../models/event';

@Component
export default class EventResponseComponent extends Vue {
  @Prop({ required: true })
  event!: Event;

  getFormattedDate(date: string, onlyHour?: boolean): string {
    return (date && moment(date).format(`${!onlyHour ? 'DD/MM/YYYY ' : ''}HH:mm`)) || '';
  }

  getDate(date: DateRange): string {
    return `${this.getFormattedDate(date.start, false)} - ${this.getFormattedDate(date.end, false)}`;
  }

  goToHomePage() {
    this.$router.push('/events');
  }
}
